import { MarketplaceDetailsRequest } from "services/api/sales/listings/types";
import { ListingEditFormValues } from "../types";

// Pretvara prazan string u null da BE ne sprema "" vrijednosti.
const orNull = (v: string) => (v.trim() === "" ? null : v);
const numOrNull = (v: string) => (v.trim() === "" ? null : Number(v));
const intOrNull = (v: string) => {
  const n = numOrNull(v);
  if (n == null) return null;
  return Math.trunc(n);
};

// Flatten `formValues.marketplaceData` u JSON payload koji BE endpoint
// `PUT /v1/sales/listings/{id}/marketplace-details` očekuje. Imena polja
// se 1:1 poklapaju s `MarketplaceDetailRequestModel` na BE-u.
export const buildMarketplacePayload = (formValues: ListingEditFormValues): MarketplaceDetailsRequest => {
  const md = formValues.marketplaceData;
  return {
    // Specifikacije
    manufacturingYear: intOrNull(md.specs.manufacturingYear),
    manufacturerId: orNull(md.specs.manufacturerId),
    modelId: orNull(md.specs.modelId),
    typeName: orNull(md.specs.typeName),
    fuelTypeCode: orNull(md.specs.fuelTypeCode),
    driveTypeCode: orNull(md.specs.driveTypeCode),
    doors: intOrNull(md.specs.doors),
    powerKw: intOrNull(md.specs.powerKw),
    transmissionCode: orNull(md.specs.transmissionCode),
    bodyShapeCode: orNull(md.specs.bodyShapeCode),
    displacementCm3: intOrNull(md.specs.displacementCm3),
    modelYear: intOrNull(md.specs.modelYear),
    seats: intOrNull(md.specs.seats),
    suspensionCode: orNull(md.specs.suspensionCode),
    colorId: orNull(md.specs.colorId),
    metallic: md.specs.metallic,
    tireWidth: orNull(md.specs.tireWidth),
    tireHeight: orNull(md.specs.tireHeight),
    tireDiameter: orNull(md.specs.tireDiameter),
    kmTraveled: intOrNull(md.specs.kmTraveled),
    vehicleConditionCode: orNull(md.specs.vehicleConditionCode),

    // Ostali podaci
    fuelConsumption: numOrNull(md.extra.fuelConsumption),
    co2Emission: numOrNull(md.extra.co2Emission),
    ecoCategoryCode: orNull(md.extra.ecoCategoryCode),
    hasGas: md.extra.hasGas,
    garaged: md.extra.garaged,
    inTrafficSinceYear: intOrNull(md.extra.inTrafficSinceYear),
    firstRegistrationYearRH: intOrNull(md.extra.firstRegistrationYearRH),
    registeredUntil: orNull(md.extra.registeredUntil),
    warrantyCode: orNull(md.extra.warrantyCode),
    extendedWarranty: md.extra.extendedWarranty,
    g1ClubWarranty: md.extra.g1ClubWarranty,
    ownerCountCode: orNull(md.extra.ownerCountCode),
    serviceBook: md.extra.serviceBook,
    chassisNumber: orNull(md.extra.chassisNumber),
    videoCallViewing: md.extra.videoCallViewing,
    internalCode: orNull(md.extra.internalCode),

    // Oprema
    airbagsCode: orNull(md.equipment.airbagsCode),
    airConditioningCode: orNull(md.equipment.airConditioningCode),
    carRadioCode: orNull(md.equipment.carRadioCode),
    equipment: md.equipment.selected,

    // Plaćanje
    priceIncludesImport: md.payment.priceIncludesImport === "" ? null : md.payment.priceIncludesImport,
    paymentOptions: md.payment.options,

    // Lokacija
    locationCountyCode: orNull(md.location.countyCode),
    locationMunicipalityCode: orNull(md.location.municipalityCode),
    locationSettlementCode: orNull(md.location.settlementCode),
    locationManualAddress: orNull(md.location.manualAddress),
    locationDisplay: md.location.display,

    // Kontakt + video — prazne liste znače da vrijede postavke oglasa.
    contactUserIds: md.contact.contactUserIds,
    locationOfficeIds: md.contact.locationOfficeIds,
    contactId: orNull(md.contact.contactId),
    youtubeUrl: orNull(md.youtubeUrl),
  };
};
